import { render } from "./DoiSuccessView.vue?vue&type=template&id=42943c81&scoped=true"
import script from "./DoiSuccessView.vue?vue&type=script&lang=js"
export * from "./DoiSuccessView.vue?vue&type=script&lang=js"

import "./DoiSuccessView.vue?vue&type=style&index=0&id=42943c81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42943c81"]])

export default __exports__